/* TLY floating stack measurer (owner: Builder B). Single writer of --tly-chat-h / --tly-chat-w / --tly-chat-lift /
   --tly-sticky-atc-h, plus --tly-header-bottom / --tly-rewards-right (Smile panel anchor). Also upgrades [data-tly-rewards] links to open the
   Smile panel via the official SmileUI.openPanel(). Reads: Shopify Inbox launcher (inside nested shadow DOM),
   body.tly-sticky-atc-visible + #TlyStickyAtc (published by the sticky-bar snippet), event tly:sticky-atc. */
(function(){
  'use strict';
  var root=document.documentElement,last={},t0=Date.now(),timer=null;
  function set(name,px,tol){
    px=Math.round(px);
    if(last[name]!==undefined&&Math.abs(last[name]-px)<=tol)return;
    last[name]=px;root.style.setProperty(name,px+'px');
  }
  function deepFind(rootNode,sel,depth){
    if(depth>6)return null;
    var hit=rootNode.querySelector(sel);if(hit)return hit;
    var all=rootNode.querySelectorAll('*');
    for(var i=0;i<all.length;i++){
      if(all[i].shadowRoot){var f=deepFind(all[i].shadowRoot,sel,depth+1);if(f)return f;}
    }
    return null;
  }
  function visibleRect(el){
    if(!el)return null;
    var r=el.getBoundingClientRect();
    if(!r.height||!r.width)return null;
    var cs=getComputedStyle(el);
    if(cs.display==='none'||cs.visibility==='hidden')return null;
    return r;
  }
  var chatEl=null;
  function measure(){
    var stickyH=0;
    var bar=document.getElementById('TlyStickyAtc');
    if(document.body&&document.body.classList.contains('tly-sticky-atc-visible')&&bar)stickyH=bar.offsetHeight;
    set('--tly-sticky-atc-h',stickyH,0);
    var vh=window.innerHeight;
    if(!chatEl||!chatEl.isConnected){
      var host=document.querySelector('shopify-chat');
      chatEl=host&&host.shadowRoot?deepFind(host.shadowRoot,'.activator-nudge .activator',0)||deepFind(host.shadowRoot,'.activator',0):null;
    }
    var cr=visibleRect(chatEl);
    if(cr&&cr.height>=30){
      set('--tly-chat-h',cr.height,2);set('--tly-chat-w',cr.width,2);
      // anything Shopify adds on top of our offset (e.g. its preview-bar offset in theme preview) lifts the chat; Rewards follows the MEASURED top
      set('--tly-chat-lift',Math.max(0,(vh-cr.bottom)-(stickyH+16)),2);
    }
    anchor();
  }
  /* ---- Rewards: header button opens the Smile panel as a dropdown under the header ---- */
  var btns=[];
  function activeBtn(){
    for(var i=0;i<btns.length;i++){var r=btns[i].getBoundingClientRect();if(r.width&&r.height&&getComputedStyle(btns[i]).visibility!=='hidden')return btns[i];}
    return null;
  }
  function anchor(){
    var hd=document.querySelector('.section-header');
    var hb=hd?Math.max(0,Math.round(hd.getBoundingClientRect().bottom)):120;
    set('--tly-header-bottom',hb+6,1);
    var b=activeBtn(),right=16;
    if(b&&window.innerWidth>749)right=Math.max(8,Math.round(document.documentElement.clientWidth-b.getBoundingClientRect().right));
    set('--tly-rewards-right',right,1);
  }
  function panelEl(){return document.querySelector('#smile-ui-container .smile-panel-frame-container:not(.smile-panel-exit)');}
  function isOpen(){return !!panelEl();}
  function sync(){var o=isOpen();for(var i=0;i<btns.length;i++)btns[i].setAttribute('aria-expanded',o?'true':'false');}
  function closePanel(){try{window.SmileUI&&window.SmileUI.closePanel&&window.SmileUI.closePanel();}catch(e){}setTimeout(sync,60);}
  function ready(cb,tries){
    if(window.SmileUI&&typeof window.SmileUI.openPanel==='function')return cb(true);
    if(tries===0&&typeof window.loadSmileSdk==='function'){try{window.loadSmileSdk();}catch(e){}}
    if(tries>=60)return cb(false);
    setTimeout(function(){ready(cb,tries+1);},250);
  }
  function openPanel(btn){
    anchor();
    if(window.SmileUI&&window.SmileUI.openPanel){window.SmileUI.openPanel();setTimeout(sync,120);return;}
    btn.setAttribute('aria-busy','true');
    ready(function(ok){
      btn.removeAttribute('aria-busy');
      if(!ok){window.location.href=btn.getAttribute('href');return;}   // SDK blocked: fall back to the Rewards page
      anchor();try{window.SmileUI.openPanel();}catch(e){window.location.href=btn.getAttribute('href');return;}
      setTimeout(sync,120);
    },0);
  }
  function preload(){if(!window.SmileUI&&typeof window.loadSmileSdk==='function'&&!preload.done){preload.done=1;try{window.loadSmileSdk();}catch(e){}}}
  function bindRewards(){
    btns=[].slice.call(document.querySelectorAll('[data-tly-rewards]'));
    btns.forEach(function(b){
      if(b.__tly)return;b.__tly=1;
      ['pointerenter','focus','touchstart'].forEach(function(ev){b.addEventListener(ev,preload,{passive:true,once:true});});
      b.addEventListener('click',function(e){
        if(e.metaKey||e.ctrlKey||e.shiftKey||e.button===1)return;   // let modified clicks open the page in a new tab
        e.preventDefault();
        var hdr=b.closest('header-drawer');
        if(hdr&&typeof hdr.closeMenuDrawer==='function'){try{hdr.closeMenuDrawer(e,hdr.querySelector('summary'));}catch(x){var dt=hdr.querySelector('details');if(dt)dt.removeAttribute('open');}}
        if(isOpen()){closePanel();return;}
        openPanel(b);
      });
    });
    anchor();
  }
  document.addEventListener('click',function(e){
    if(!isOpen())return;
    if(e.target.closest&&(e.target.closest('[data-tly-rewards]')||e.target.closest('#smile-ui-container')))return;
    closePanel();
  },true);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&isOpen()){closePanel();var b=activeBtn();if(b)try{b.focus();}catch(x){}}});
  window.addEventListener('blur',function(){setTimeout(function(){if(isOpen()&&document.activeElement&&document.activeElement.tagName==='IFRAME'&&!document.activeElement.closest('#smile-ui-container')){closePanel();}},0);});
  window.__tlyRewardsBind=bindRewards;
  function throttled(){if(timer)return;timer=setTimeout(function(){timer=null;measure();},120);}
  function start(){
    bindRewards();measure();setInterval(sync,400);
    var iv=setInterval(function(){measure();if(Date.now()-t0>15000)clearInterval(iv);},500);
    window.addEventListener('resize',throttled,{passive:true});
    window.addEventListener('scroll',throttled,{passive:true});
    document.addEventListener('tly:sticky-atc',throttled);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
